import service  from "@/utils/http";



//适用场景：用户关注公司
export function UserData(data) {
  return service({
    url: `/UserFollow/user_follow`,
    method: "post",
    data:data
  });
}

//适用场景：用户取消关注公司
export function delUserData(data) {
  return service({
    url: `/UserFollow/del_user_follow`,
    method: "post",
    data:data
  });
}


//适用场景：关注列表
export function UserList(data) {
  return service({
    url: `/UserFollow/user_follow_list`,
    method: "post",
    data:data
  });
}

//适用场景：用户浏览公司
export function historyData(data) {
  return service({
    url: `/UserTracks/user_tracks`,
    method: "post",
    data:data
  });
}
//适用场景：取消用户浏览
export function delHistoryData(data) {
  return service({
    url: `/UserTracks/del_user_tracks`,
    method: "post",
    data:data
  });
}

//适用场景：浏览历史列表
export function getHistoryData(data) {
  return service({
    url: `/UserTracks/user_tracks_list`,
    method: "post",
    data:data
  });
}


//设置子账号密码
export function setSubPassword(data) {
  return service({
    url: `/user/setSubPassword`,
    method: "post",
    data:data
  });
}

//上传头像
export function setAvatar(data) {
  return service({
    url: `/user/setAvatar`,
    method: "post",
    data:data
  });
}

//获取个人信息
export function getUserInfo(data) {
  return service({
    url: `/user/getUserInfo`,
    method: "post",
    data:data
  });
}
//子账号列表
export function SubAccountList(data) {
  return service({
    url: `/user/SubAccountList`,
    method: "post",
    data:data
  });
}

//固定热门企业推荐表
export function hostEnterprise(data) {
  return service({
    url: `/HostEnterprise/host_enterprise_fixed_list`,
    method: "post",
    data:data
  });
}


//企业信息导出excel
export function enterpriseExport(data) {
  return service({
    url: `/Qcc/enterpriseExport`,
    method: "post",
    data:data,
    responseType: "blob",
  });
}
//企业股东信息
export function ECIPartnerExport(data) {
  return service({
    url: `/Qcc/qcc_ECIPartner`,
    method: "post",
    data:data,
  });
}
//企业对外投资核查
export function InvestmentCheckExport(data) {
  return service({
    url: `/Qcc/qcc_InvestmentCheck`,
    method: "post",
    data:data,
  });
}
//商标查询
export function SearchByApplicant(data) {
  return service({
    url: `/Qcc/qcc_SearchByApplicant`,
    method: "post",
    data:data,
  });
}
//专利查询
export function SearchMultiPatents(data) {
  return service({
    url: `/Qcc/qcc_SearchMultiPatents`,
    method: "post",
    data:data,
  });
}
//著作权
export function SearchCopyRight(data) {
  return service({
    url: `/Qcc/qcc_SearchCopyRight`,
    method: "post",
    data:data,
  });
}

//备案网站查询
export function GetCompanyWebSite(data) {
  return service({
    url: `/Qcc/qcc_GetCompanyWebSite`,
    method: "post",
    data:data,
  });
}







